/**
 * Find the nearest Element UI dialog body from a DOM node or Vue component.
 */
export function findDialogBody (startNode) {
  const root = startNode && (startNode.$el || startNode)
  if (!root) return null

  if (root.classList && root.classList.contains('el-dialog__body')) {
    return root
  }

  if (root.querySelector) {
    const nested = root.querySelector('.el-dialog__body')
    if (nested) return nested
  }

  let el = root.parentElement
  while (el) {
    if (el.classList && el.classList.contains('el-dialog__body')) {
      return el
    }
    el = el.parentElement
  }
  return null
}

function findDialogShell (startNode) {
  const root = startNode && (startNode.$el || startNode)
  if (!root || !root.querySelector) return { wrapper: null, dialog: null, body: null }

  const wrapper = root.classList && root.classList.contains('el-dialog__wrapper')
    ? root
    : root.closest('.el-dialog__wrapper')
  const dialog = wrapper
    ? wrapper.querySelector('.el-dialog')
    : (root.classList && root.classList.contains('el-dialog') ? root : root.closest('.el-dialog'))
  const body = dialog
    ? dialog.querySelector('.el-dialog__body')
    : findDialogBody(root)

  return { wrapper, dialog, body }
}

/** Reset scroll on wrapper / dialog / body (fullscreen may scroll any of these). */
export function resetDialogBodyScroll (startNode) {
  const { wrapper, dialog, body } = findDialogShell(startNode)
  ;[wrapper, dialog, body].forEach((el) => {
    if (el) el.scrollTop = 0
  })
}

/** Retry after layout / async content paint. */
export function scheduleDialogScrollReset (startNode, delays = [0, 100, 300, 600, 1000, 1500]) {
  const run = () => resetDialogBodyScroll(startNode)
  run()
  requestAnimationFrame(run)
  delays.forEach((ms) => {
    setTimeout(run, ms)
  })
}
